import React, { useMemo } from 'react'

import { FormText, Icon, TableV2 } from 'src/components'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'

interface ClientThresholdListProps {
  thresholds: IThreshold[]
  onUpdate: (threshold: IThreshold) => void
  onDelete: (threshold: IThreshold) => void
  loading: boolean
}

export const ThresholdList = ({
  thresholds,
  onUpdate,
  onDelete,
  loading,
}: ClientThresholdListProps) => {
  const headers: ITableHeader[] = [
    {
      label: 'Color',
      show: true,
      type: 'custom',
      value: [],
      custom: threshold => <FormText type={'color'} value={threshold.rgb} disabled />,
    },
    { label: 'Mínimo', show: true, type: 'number', value: ['min'] },
    { label: 'Máximo', show: true, type: 'number', value: ['max'] },
    {
      label: 'Acciones',
      show: true,
      type: '',
      value: [],
      custom: threshold => (
        <div className={'d-flex'}>
          <Icon
            icon={faTrash}
            style={{ marginRight: '5px' }}
            color={'secondary'}
            onClick={() => onDelete(threshold)}
            tooltip={'Eliminar'}
          />
          <Icon
            icon={faEdit}
            color={'primary'}
            tooltip={'Editar'}
            onClick={() => onUpdate(threshold)}
          />
        </div>
      ),
    },
  ]

  const items = useMemo(() => {
    return thresholds.sort((a, b) => a.min - b.min)
  }, [thresholds])

  return (
    <TableV2
      // @ts-ignore
      headers={headers}
      items={items}
      loading={loading}
    />
  )
}
